import { render, staticRenderFns } from "./leaderboard-fab.vue?vue&type=template&id=280b3d92&scoped=true&"
import script from "./leaderboard-fab.vue?vue&type=script&lang=js&"
export * from "./leaderboard-fab.vue?vue&type=script&lang=js&"
import style0 from "./leaderboard-fab.vue?vue&type=style&index=0&id=280b3d92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280b3d92",
  null
  
)

export default component.exports